import { useIsMinWidthMd } from '@/hooks/useIsMinWidthMd'

// @todo: rework to use CSS variables instead?
export function usePageContentPadding() {
  const isMinWidthMd = useIsMinWidthMd()

  const x = isMinWidthMd ? '30px' : '15px'
  const y = isMinWidthMd ? '35px' : '30px'

  return { x, y, xAndY: `${y} ${x}` }
}
